"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeDate;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * validates and normalizes date input.
 * @returns string date in YYYY-MM-DD format if input is valid, otherwise empty string.
 */
function normalizeDate(date) {
  if (!date || !(0, _dayjs["default"])(date).isValid()) {
    return '';
  }

  return (0, _dayjs["default"])(date).format('YYYY-MM-DD');
}